export type Brands =
  | "UNKNOWN"
  | "DINERS_CLUB_INTERNATIONAL"
  | "DANKORT"
  | "MIR"
  | "TROY"
  | "UATP"
  | "CHINA_T_UNION"
  | "CHINA_UNION_PAY"
  | "AMERICAN_EXPRESS"
  | "AMEX"
  | "VERVE"
  | "RUPAY"
  | "DISCOVER"
  | "JCB"
  | "MASTERCARD"
  | "INTERPAYMENT"
  | "INSTAPAYMENT"
  | "MAESTRO"
  | "VISA"
  | "LANKAPAY"
  | "DINERS_CLUB";

const logoByBrand = {
  UNKNOWN: "/card-brands/non-brand.svg",
  DINERS_CLUB_INTERNATIONAL: "/card-brands/non-brand.svg",
  DANKORT: "/card-brands/non-brand.svg",
  MIR: "/card-brands/non-brand.svg",
  TROY: "/card-brands/non-brand.svg",
  UATP: "/card-brands/non-brand.svg",
  CHINA_T_UNION: "/card-brands/non-brand.svg",
  CHINA_UNION_PAY: "/card-brands/non-brand.svg",
  AMERICAN_EXPRESS: "/card-brands/american-express.svg",
  AMEX: "/card-brands/american-express.svg",
  VERVE: "/card-brands/non-brand.svg",
  RUPAY: "/card-brands/non-brand.svg",
  DISCOVER: "/card-brands/discover.svg",
  JCB: "/card-brands/non-brand.svg",
  MASTERCARD: "/card-brands/mastercard.svg",
  INTERPAYMENT: "/card-brands/non-brand.svg",
  INSTAPAYMENT: "/card-brands/non-brand.svg",
  MAESTRO: "/card-brands/non-brand.svg",
  VISA: "/card-brands/visa.svg",
  LANKAPAY: "/card-brands/non-brand.svg",
  DINERS_CLUB: "/card-brands/non-brand.svg",
  BANK: "/card-brands/bank.svg",
};

export const getCardBrand = (cardString: string) => {
  let brand: Brands | "BANK" | null = null;
  let cardNumber: string;
  let logo: string;

  // Check if cardString contains ":"
  const hasColon = cardString.includes(":");

  if (hasColon) {
    // If it has ":", split and check the brand part
    const parts = cardString.split(":");
    const brandPart = parts[0].trim().replace(/ /g, "_").toUpperCase();
    brand = brandPart as Brands;
    cardNumber = parts[1]?.trim().match(/\d+/g)?.join("").slice(-4) || "";
  } else {
    // If no ":", check if the string contains a Brands value
    const normalizedString = cardString.trim().replace(/ /g, "_").toUpperCase();

    // Check if the normalized string starts with any brand name
    const brandNames: Brands[] = [
      "DINERS_CLUB_INTERNATIONAL",
      "DANKORT",
      "CHINA_T_UNION",
      "CHINA_UNION_PAY",
      "AMERICAN_EXPRESS",
      "DINERS_CLUB",
      "DISCOVER",
      "MASTERCARD",
      "AMEX",
      "VISA",
      "JCB",
      "MAESTRO",
      "RUPAY",
      "VERVE",
      "MIR",
      "TROY",
      "UATP",
      "INTERPAYMENT",
      "INSTAPAYMENT",
      "LANKAPAY",
    ];

    // Check if the string starts with any brand name
    const matchingBrand = brandNames.find((brandName) => normalizedString.startsWith(brandName));

    if (matchingBrand) {
      // It's a card with a brand (no colon)
      brand = matchingBrand;
      // Extract the last 4 digits from the entire string
      cardNumber = cardString.match(/\d+/g)?.join("").slice(-4) || "";
    } else {
      // It's a bank account (no colon and no brand match)
      brand = "BANK";
      cardNumber = cardString.match(/\d+/g)?.join("").slice(-4) || "";
    }
  }

  // Determine logo based on brand
  if (brand === "BANK") {
    logo = logoByBrand.BANK;
  } else if (brand && brand in logoByBrand) {
    logo = logoByBrand[brand as Brands] || logoByBrand.UNKNOWN;
  } else {
    logo = logoByBrand.UNKNOWN;
  }

  return {
    logo,
    cardNumber: "Last 4 : " + cardNumber,
  };
};
